import { NumberRangeSearchFilterDTO, NumberRangeSearchFilterId, SearchFilterDTO } from "../..";

const numberRangeSearchTypes: Record<NumberRangeSearchFilterId, true> = {
  "last-sale-date": true,
  "lot-area-id": true,
  "lot-cluster-area-id": true,
  "developed-area-id": true,
  "planning-applications-number-of-units": true,
  "us-total-wetlands-coverage-id": true,
};

export function isNumberRangeSearchDTO(
  filter: SearchFilterDTO
): filter is NumberRangeSearchFilterDTO {
  return filter.id in numberRangeSearchTypes;
}
